const submitBtn = document.getElementById('submit-btn');
const inputs = [...document.querySelectorAll('.form__input')];

function validate() {
  const isIncomplete = inputs.some(input => !input.value);
  submitBtn.disabled = isIncomplete;
}

document.addEventListener('input', validate);
validate();

sessionStorage.removeItem("is_active");